import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation';
import Maps from '../../components/Maps';

const markers = [
  {
    title: 'Main Terminal',
    id: 1,
    type: 'Terminal',
    lat: '40.717738',
    lng: '-73.240394',
    address: 'Gate 1, 99 Maple Ave.',
    noLabel: true,
  },
];

export default () => (
  <div>
    <Helmet
      title='Fire Island Ferries | Contact Us'
      meta={[
        {
          name: 'description',
          content: 'Fire Island Ferries Contact Information',
        },
        {
          name: 'keywords',
          content: 'Fire Island, New York, Long Island, Ferries, Water Taxi',
        },
      ]}
    />
    <Navigation />
    <div className='container page'>
      <div className='row'>
        <div className='col-xl'>
          <div className='heading'>
            <h2>Info</h2>
            <h1>Contact Us</h1>
          </div>
          <p>
            Have a question, a comment, or a concern? Here are the best ways to
            contact us.
          </p>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-6'>
          <h3>
            Phones <i className='far fa-phone' />
          </h3>
          <div className='split-line'>
            <span className='float-left'>Main Terminal</span>
            <span className='float-right'>631.665.3600</span>
          </div>
          <div className='clearfix' />
          <div className='split-line'>
            <span className='float-left'>West Terminal</span>
            <span className='float-right'>631.665.2115</span>
          </div>
          <div className='clearfix' />
          <div className='split-line'>
            <span className='float-left'>Saltaire Terminal</span>
            <span className='float-right'>631.665.7474</span>
          </div>
          <div className='clearfix' />
          <div className='split-line'>
            <span className='float-left'>Freight Info:</span>
            <span className='float-right'>631.647.3055</span>
          </div>
          <div className='clearfix' />
          <div className='split-line'>
            <span className='float-left'>FI Water Taxi</span>
            <span className='float-right'>631.665.8885</span>
          </div>
          <div className='clearfix' />
          <div className='split-line'>
            <span className='float-left'>Fax</span>
            <span className='float-right'>631.665.7656</span>
          </div>
          <div className='clearfix' />
        </div>
        <div className='col-md-6'>
          <h3>
            E-Mail <i className='far fa-envelope' />
          </h3>
          <div className='split-line'>
            <span className='float-left'>Information</span>
            <span className='float-right'>info@fireislandferries.com</span>
          </div>
          <div className='clearfix' />
          <div className='split-line'>
            <span className='float-left'>Freight</span>
            <span className='float-right'>freight@fireislandferries.com</span>
          </div>
          <div className='clearfix' />
          <div className='split-line'>
            <span className='float-left'>Advertising</span>
            <span className='float-right'>ads@fireislandferries.com</span>
          </div>
          <div className='clearfix' />
          <div className='split-line'>
            <span className='float-left'>Media/Production</span>
            <span className='float-right'>media@fireislandferries.com</span>
          </div>
          <div className='clearfix' />
          <div className='split-line'>
            <span className='float-left'>FI Water Taxi:</span>
            <span className='float-right'>info@fireislandwatertaxi.com</span>
          </div>
          <div className='clearfix' />
          <div className='split-line'>
            <span className='float-left'>Website Help:</span>
            <span className='float-right'>admin@fireislandferries.com</span>
          </div>
          <div className='clearfix' />
        </div>
      </div>
      <div className='row'>
        <div className='col-md-6'>
          <h3>
            Mailing Address <i className='far fa-envelope-open' />
          </h3>
          <p>
            Fire Island Ferries Inc.
            <br />
            P.O. Box 5311
            <br />
            Bay Shore, NY 11706
          </p>
        </div>
        <div className='col-md-6'>
          <h3>
            Physical Address <i className='fas fa-map-marker-alt' />
          </h3>
          <span className='lead'>(Use for freight shipments)</span>
          <p>
            Fire Island Ferries Inc.
            <br />
            99 Maple Ave.
            <br />
            Bay Shore, NY 11706
          </p>
        </div>
      </div>
    </div>
    <Maps lat='40.718967' lng='-73.245097' zoom='15' markers={markers} />
  </div>
);
